import React, { useState, useEffect } from "react";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import WifiIcon from "@mui/icons-material/Wifi";

const OfflineBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);
  const [bannerType, setBannerType] = useState("offline"); // "offline" | "restored"

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setBannerType("restored");
      setShowBanner(true);
      // Auto-hide online confirmation after 3 seconds
      setTimeout(() => {
        setShowBanner(false);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setBannerType("offline");
      setShowBanner(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Initial state check
    if (!navigator.onLine) {
      handleOffline();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  const isOffline = bannerType === "offline";

  return (
    <div 
      className={`offline-banner-container ${isOffline ? "offline" : "restored"}`}
      style={{
        position: "fixed",
        top: "env(safe-area-inset-top, 0px)",
        left: "0",
        right: "0",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px 16px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        fontFamily: "var(--font-family)",
        fontSize: "13px",
        fontWeight: 600,
        gap: "8px"
      }}
    >
      {isOffline ? (
        <>
          <WifiOffIcon sx={{ fontSize: 18, color: "#e11d48" }} />
          <span style={{ color: "#9f1239" }}>
            You are offline. Running in offline mode with cached data.
          </span>
        </>
      ) : (
        <>
          <WifiIcon sx={{ fontSize: 18, color: "#16a34a" }} />
          <span style={{ color: "#166534" }}>
            Connection restored! Reconnecting...
          </span>
        </>
      )}

      <style>{`
        .offline-banner-container.offline {
          background-color: rgba(254, 226, 226, 0.9);
          border-bottom: 1px solid rgba(251, 113, 133, 0.3);
        }
        .offline-banner-container.restored {
          background-color: rgba(220, 252, 231, 0.9);
          border-bottom: 1px solid rgba(74, 222, 128, 0.3);
          animation: slideUp 0.3s forwards ease-in;
          animation-delay: 2.7s;
        }
        @keyframes slideUp {
          to {
            transform: translateY(-100%);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default OfflineBanner;
